document.addEventListener('click', function(event) {
  const clickedElement = event.target;
  // Check if clicked element has 'data-copy-id' attribute
  if (clickedElement.dataset.copyId) {
    const value = clickedElement.getAttribute('data-copy-id'),
          downloadUrl = clickedElement.dataset.download;

    // Use navigator.clipboard.writeText to copy
    navigator.clipboard.writeText(value);

    setTimeout(() => {
      // Open download URL in new tab
      window.open(downloadUrl, '_blank');
    }, 1000);

  }
});